<template>
    <Card
        :size="`col-md-10 col-lg-8 col-xl-6 max-xl-670`"
        :newLayout="true"
        :hideFooter="false"
    >
        <template slot="card-header">
            <h1 v-translate>Sign up to SmartCharts</h1>
            <EnrolmentProgress :currentStage="$options.name" />
        </template>
        <template slot="card-body">
            <h3
                class="text-center mb-4"
                v-translate
            >Confirm your application</h3>

            <div class="row justify-content-center">
                <div class="col-md-10">
                    <div class="confirmation">
                        <div class="confirmation-panel confirmation-top">
                            <div class="row">
                                <div class="col-auto">
                                    <h4
                                        class="confirmation-top__header"
                                        v-translate
                                    >Summary</h4>
                                </div>
                                <div class="confirmation-top__icon">
                                    <svg-rndr
                                        :width="80"
                                        svg="profile-default.svg"
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="confirmation-panel confirmation-personal">
                            <h5 class="confirmation-panel__header">
                                <translate>Personal Info</translate>
                                <span class="confirmation__edit">
                                    <router-link :to="{ name: 'enrolment-register', params: { user: this.user } }">
                                        <svg-rndr
                                            :inline="true"
                                            svg="edit-circle.svg"
                                        />
                                    </router-link>
                                </span>
                            </h5>
                            <div class="row">
                                <div class="col mb-2">
                                    {{ user.email }}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    {{ user.full_name }}<br>
                                    {{ user.mobile }}<br>
                                    {{ user.experience }}<br>
                                </div>
                                <div class="col-md-6 mt-3 mt-md-0">
                                    <address>
                                        {{ user.home_country }}<br>
                                        <template v-if="user.home_house_name">
                                            {{ user.home_house_name }}<br v-if="user.home_house_name">
                                        </template>
                                        {{ user.home_house_number }} {{ user.home_street }}<br>
                                        <template v-if="user.home_state">
                                            {{user.home_state}}<br>
                                        </template>
                                        {{ user.home_city }}<br>
                                        {{ user.home_postcode }}<br>
                                    </address>
                                </div>
                            </div>
                        </div>
                        <div class="confirmation-panel confirmation-subscription">
                            <h5 class="confirmation-panel__header">
                                <translate>Subscription</translate>
                                <span class="confirmation__edit">
                                    <router-link :to="{ name: 'enrolment-subscription', params: { user: this.user } }">
                                        <svg-rndr
                                            :inline="true"
                                            svg="edit-circle.svg"
                                        />
                                    </router-link>
                                </span>
                            </h5>
                            <template v-if="product">
                                <div class="row">
                                    <div class="col">
                                        {{ product.name }}
                                    </div>
                                    <div class="col">
                                        <span class="confirmation-subscription__price">
                                            <translate>TOTAL</translate> - ${{ product.price }} {{ paymentPeriod }}
                                        </span>
                                    </div>
                                </div>
                                <small
                                    class="confirmation-subscription__footer mt-2"
                                    v-if="product.price > 0"
                                >{{ subscriptionBody }}</small>
                            </template>
                            <template v-else>
                                <div class="row justify-content-center">
                                    <div class="col-md-8 col-lg-7 loader loader--inline">
                                        <loader
                                            :width="25"
                                            :height="25"
                                        />
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div class="confirmation-panel confirmation-subscription">
                            <h5 class="confirmation-panel__header">
                                <translate>Payment Details</translate>
                                <span class="confirmation__edit">
                                    <router-link :to="{ name: 'enrolment-payment', params: { user: this.user } }">
                                        <svg-rndr
                                            :inline="true"
                                            svg="edit-circle.svg"
                                        />
                                    </router-link>
                                </span>
                            </h5>
                            <template v-if=" Object.keys(payment).length > 0 && payment.cb_token != ''">
                                <div class="row">
                                    <div class="col">
                                        {{payment.card_type}}
                                    </div>
                                    <div class="col">
                                        <span class="confirmation-subscription__price">
                                            <!-- {{payment.card.brand}} -->
                                        </span>
                                    </div>
                                </div>
                            </template>
                            <template v-else>
                                <div class="row justify-content-center">
                                    <div class="col-md-8 col-lg-7 loader loader--inline">
                                        NO PAYMENT METHOD
                                        <!-- <loader
                                            :width="25"
                                            :height="25"
                                        /> -->
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
            <form
                ref="form"
                method="POST"
                :action="$laraRoute('enrol')"
                @submit.prevent="processStage"
                id="enrol-form"
                novalidate
            >
            </form>
        </template>
        <template slot='card-footer'>
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <flash-message></flash-message>
                </div>
            </div>
            <EnrolmentFooter
                :isValid="isValid"
                :submitHandler="(Object.keys(payment).length > 0 && payment.cb_token != '' ? submitForm : showErrMsg)"
                :processStage="processStage"
                :prev="prev"
                :nextBtn="'Pay Now' | translate"
            />
        </template>
    </Card>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Card from '@C/Card.vue';
import Checkbox from '@C/Checkbox';
import EnrolmentFooter from './Footer';
import EnrolmentProgress from '@C/EnrolmentProgress';
import EnrolmentMixin from '@M/enrolment';
import errorsMixin from '@M/errors';
import validator from '@M/validationWrapper';

export default {
    name: 'Confirmation',
    beforeMount() {
        this.loadProduct();
    },
    computed: {
        ...mapState('Enrolment', ['product', 'user', 'payment']),
        paymentPeriod() {
            if (!this.product.months) return;

            switch (this.product.months) {
                case 1:
                    return this.$gettext('per month');
                case 12:
                    return this.$gettext('per year');
                case 6:
                default:
                    let translated = this.$gettext('every %{ months } months');

                    return this.$gettextInterpolate(translated, {
                        months: this.product.months
                    });
            }
        },
        subscriptionBody() {
            if (!this.product.months) {
                return this.$gettext(
                    'A one-off payment for the subscription will be made after completing enrolment'
                );
            }

            return this.$gettext(
                'First payment for the subscription will be made after completing enrolment'
            );
        }
    },
    methods: {
        ...mapActions('Enrolment', ['loadProduct']),
        showErrMsg() {
            this.setFlash(
                {
                    message: 'No Payment Method',
                    key: 'error'
                }
            )
        }
    },
    components: {
        Card,
        Checkbox,
        EnrolmentFooter,
        EnrolmentProgress
    },
    mixins: [EnrolmentMixin, errorsMixin, validator]
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/stages/Enrolment/Confirmation.vue